module.exports = __webpack_public_path__ + "img/1.33_Russian_road_sign.fca635a9.svg";